module.exports = __webpack_public_path__ + "img/montage-logo.cc873e16.png";